import React, { useCallback, useEffect, useState } from 'react';
import cls from './signIn.module.scss';
import { Col, Form, Row } from 'react-bootstrap';
import _ from 'lodash';
import { Icon } from 'lb-components';
import cx from 'classnames';
import { Api } from 'lb-store';

const SignInHistory = ({ setRoute }) => {
  const [authHistory, setAuthHistory] = useState();

  useEffect(() => {
    Api.User.AuthHistory().then((response) => {
      if (response.status) {
        setAuthHistory(_.groupBy(response.data.data, 'DATE'));
      }
    });
  }, []);
  return (
    <div className={cls.tab}>
      <div className={cls.tabContent}>
        <div className={cls.dataList}>
          {_.map(authHistory, (entries, title) => {
            return (
              <div key={title}>
                <h3 className={cls.header}>{title}</h3>
                <div className={cls.listContainer}>
                  {_.map(entries, (v, k) => {
                    return (
                      <div key={k} className={cls.item}>
                        <div className={cls.description}>{v.TIME}</div>
                        <div className={cls.ip}>
                          <span>IP</span>
                          &nbsp; &nbsp;
                          <span>{v.ip}</span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SignInHistory;
